module.exports = __webpack_public_path__ + "static/img/wisdompain.649f6e56.png";